import GlassCard from '../../GlassCard';
import SectionHeader from '../../ui/SectionHeader';
import ProjectCard from '../projects/ProjectCard';
import { projectsData } from '../../../assets/data/projectData';

export default function Projects() {
  return (
    <section id="projects" className="min-h-screen flex items-center justify-center px-4 py-20">
      <div className="max-w-4xl w-full">
        <GlassCard className="border-emerald-400/30">
          <SectionHeader title="Projects" />
          
          <div className="grid gap-6">
            {projectsData.map((project, projectIndex) => (
              <ProjectCard 
                key={projectIndex} 
                project={project} 
                projectIndex={projectIndex} 
              />
            ))}
          </div>
        </GlassCard>
      </div>
    </section>
  );
}